import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { OutlinedBtnPrimary, SectionTitle } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useMapaPesoCidade, { MAPA_PESO_CIDADE_ACTIONS } from './MapaPesoCidadeState'

export default connect()(MapaPesoCidade)

function MapaPesoCidade({ ciclo, dispatch }) {
  const { state, actions } = useMapaPesoCidade(ciclo)

  useEffect(() => {
    switch (state.loading) {
      case MAPA_PESO_CIDADE_ACTIONS.EXPORTANDO_MAPA:
        dispatch(showLoadingBox('Exportando Mapa de Peso por Cidade', 'Aguarde . . .'))
        break
      default:
        dispatch(hideLoadingBox())
        break
    }
  }, [state.loading])

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      actions.resetMessages()
    state.successMessage &&
      dispatch(showMessageBox(state.successMessage, null)) &&
      actions.resetMessages()
  }, [state.errorMessage, state.successMessage])

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title="Exportar Mapa de Peso por Cidade" />
      </div>
      <div className="p-col-12">
        <OutlinedBtnPrimary
          label="Exportar Mapa de Peso por Cidade"
          onClick={actions.onBtnExportarClick}
        />
      </div>
    </div>
  )
}
